import {mount} from 'svelte';
import Page from './Page.svelte';

const target = document.getElementById('page') as HTMLDivElement;

export default mount(Page, {target});
